import type { StepCategory } from '@corner/shared';

interface CoTCategoryIconProps {
  category: StepCategory;
  size?: number;
  active?: boolean;
}

const MUTED = '#9E9189';
const ACTIVE = '#D97645';

export default function CoTCategoryIcon({ category, size = 12, active }: CoTCategoryIconProps) {
  const c = active ? ACTIVE : MUTED;
  const s = { flexShrink: 0 } as const;

  switch (category) {
    case 'file':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M3 1h4l3 3v7H3V1z" stroke={c} strokeWidth="1.2" strokeLinejoin="round" fill="none" />
          <path d="M7 1v3h3" stroke={c} strokeWidth="1.2" strokeLinejoin="round" fill="none" />
        </svg>
      );

    case 'search':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <circle cx="5" cy="5" r="3.5" stroke={c} strokeWidth="1.2" fill="none" />
          <path d="M8 8l2.5 2.5" stroke={c} strokeWidth="1.2" strokeLinecap="round" />
        </svg>
      );

    case 'edit':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M2 10l1-3L9 1l2 2-6 6-3 1z" stroke={c} strokeWidth="1.2" strokeLinejoin="round" fill="none" />
        </svg>
      );

    case 'web':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <circle cx="6" cy="6" r="4.5" stroke={c} strokeWidth="1.2" fill="none" />
          <ellipse cx="6" cy="6" rx="2" ry="4.5" stroke={c} strokeWidth="1.0" fill="none" />
          <path d="M1.5 6h9" stroke={c} strokeWidth="1.0" />
        </svg>
      );

    case 'draft':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M3 1h6v10H3V1z" stroke={c} strokeWidth="1.2" strokeLinejoin="round" fill="none" />
          <path d="M5 4h2M5 6h2M5 8h1" stroke={c} strokeWidth="1.0" strokeLinecap="round" />
        </svg>
      );

    case 'sign':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M2 10c1-2 2-4 3-4s1.5 3 3 1 2-3 2-3" stroke={c} strokeWidth="1.2" strokeLinecap="round" fill="none" />
        </svg>
      );

    case 'check':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M3 6l2 2 4-4" stroke={c} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="6" cy="6" r="4.5" stroke={c} strokeWidth="1.0" fill="none" />
        </svg>
      );

    case 'flag':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <path d="M3 2v8" stroke={c} strokeWidth="1.2" strokeLinecap="round" />
          <path d="M3 2h6l-2 2.5L9 7H3" stroke={c} strokeWidth="1.2" strokeLinejoin="round" fill="none" />
        </svg>
      );

    case 'clarify':
      return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" style={s}>
          <rect x="1" y="1" width="10" height="8" rx="2" stroke={c} strokeWidth="1.2" fill="none" />
          <path d="M4 11l2-2" stroke={c} strokeWidth="1.2" strokeLinecap="round" />
          <text x="6" y="7.5" textAnchor="middle" fill={c} fontSize="6" fontWeight="700" fontFamily="system-ui">?</text>
        </svg>
      );

    default:
      return null;
  }
}
